import { render, staticRenderFns } from "./Layers.vue?vue&type=template&id=5bfd97b3"
import script from "./Layers.vue?vue&type=script&lang=js"
export * from "./Layers.vue?vue&type=script&lang=js"
import style0 from "./Layers.vue?vue&type=style&index=0&id=5bfd97b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports